import { render, staticRenderFns } from "./EmailNotificationsCreate.vue?vue&type=template&id=7c149036"
import script from "./EmailNotificationsCreate.vue?vue&type=script&lang=ts"
export * from "./EmailNotificationsCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports